import { Lightbulb } from "lucide-react";
export const AiAgentsTakeaway = () => (
  <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl border border-primary/20 p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center shrink-0"><Lightbulb className="w-6 h-6 text-primary" /></div>
      <div><h3 className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h3>
        <p className="text-muted-foreground leading-relaxed">AI agents aren't just chatbots — they're autonomous workers that can research, analyze, and execute multi-step tasks. Start with one repetitive workflow and automate it completely before scaling.</p>
      </div>
    </div>
  </div>
);
